interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  action?: { label: string; href: string };
}

export default function SectionHeading({ kicker, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
      <div className="max-w-2xl">
        <div className="inline-flex items-center gap-2 mb-4">
          <span className="w-8 h-px bg-primary-500" />
          <span className="text-xs md:text-sm font-semibold tracking-[0.28em] text-primary-700">
            {kicker}
          </span>
        </div>
        <h3 className="font-heading font-black text-foreground-950 text-2xl md:text-4xl leading-tight">
          {title}
        </h3>
        {desc && (
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
        )}
      </div>
      {action && (
        <a
          href={action.href}
          className="shrink-0 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-100 text-secondary-900 text-sm font-semibold hover:bg-secondary-200 transition-colors whitespace-nowrap"
        >
          {action.label}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line" />
          </span>
        </a>
      )}
    </div>
  );
}